import { useMemo } from "react";
import { getDistanceMeters } from "@wondermaps/maps/turf";
import type { Point } from "geojson";

export interface POIWithLocation {
  id: string;
  location: Point | null;
}

/**
 * Computes distances from user location to all POIs
 * @param pois - Array of POIs with id and location
 * @param userLocation - User's current location { lng, lat } or null
 * @returns Map<poiId, distanceInMeters>
 */
export function usePOIDistances(
  pois: POIWithLocation[],
  userLocation: { lng: number; lat: number } | null
): Map<string, number> {
  return useMemo(() => {
    if (!userLocation) {
      return new Map<string, number>();
    }

    const distances = new Map<string, number>();
    const userCoords = { x: userLocation.lng, y: userLocation.lat };

    for (const poi of pois) {
      if (poi.location) {
        const [lng, lat] = poi.location.coordinates as [number, number];
        const dist = getDistanceMeters(userCoords, { x: lng, y: lat });
        distances.set(poi.id, dist);
      }
    }

    return distances;
  }, [pois, userLocation]);
}
